import Stack from "@mui/material/Stack";
import React, { useEffect, useRef } from "react";
import { Message } from "../../interfaces/sirius";
import MessageBubble from "./MessageBubble";

interface MessageListProps {
  messages: Message[];
  withActions?: boolean;
  handleFeedback?: Function;
  loading: boolean;
}

const MessageList: React.FC<MessageListProps> = ({
  messages,
  withActions = true,
  handleFeedback,
  loading,
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  }, [messages.length]);

  return (
    <div className="w-full flex flex-1 overflow-y-auto justify-center my-4">
      <Stack gap={3} className="w-full px-4 lg:max-w-3xl xl:max-w-4xl">
        {messages.map((message, index) => (
          <MessageBubble
            key={message.id}
            message={message}
            isLatestMessage={index === messages.length - 1 && !loading}
            handleFeedback={handleFeedback!}
            withActions={withActions}
          />
        ))}
        {loading && (
          <span className="flex w-full h-6 items-end gap-2">
            <span className="animate-bounce size-3 rounded-full bg-[--mui-palette-primary-main] opacity-50" />
            <span className="animate-bounce size-3 rounded-full bg-[--mui-palette-primary-main] opacity-50" />
            <span className="animate-bounce size-3 rounded-full bg-[--mui-palette-primary-main] opacity-50" />
          </span>
        )}
        <div ref={messagesEndRef} />
      </Stack>
    </div>
  );
};

export default MessageList;
